import formatters from './formatters.js';
import httpRequest from './httpRequest.js';
import currency from 'currency.js';
import * as ibantools from 'ibantools';

var validators = {
	helpers: {
		/**
		 * Checks if a value is numeric
		 * This is based on jQuery's isNumeric function without the jQuery dependency
		 *
		 * @param {*} value - The value to check
		 * @returns {string} 'success' if numeric, 'error' otherwise
		 */
		isNumeric: function (value) {
			// Convert the value to a string for consistency
			var type = typeof value;
			if (type === 'number' || type === 'string') {
				var strValue = String(value);

				// Trim whitespace
				strValue = strValue.trim();

				// Check if it's a valid number
				if (strValue !== '') {
					// Use parseFloat to handle both integers and decimals
					// Then check if it's finite and not NaN
					return !isNaN(strValue) && isFinite(strValue);
				}
			}
			return false;
		},
	},

	/**
	 * Notempty validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	notEmpty: function (value) {
		if (!value || value == '' || value == null || value == 'undefined') {
			return 'error';
		} else {
			return 'success';
		}
	},

	/**
	 * Required validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	required: function (value) {
		if (value == '') {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Isnull validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	isNull: function (value) {
		if (value === null) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Alphanumeric validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	alphanumeric: function (value) {
		var filter = /^[a-z0-9]+$/i;
		if (typeof value !== 'string' || !filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Alphabetic_dot validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	alphabetic_dot: function (value) {
		var filter = /^[a-z\.]+$/i;
		if (typeof value !== 'string' || !filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Alphabetic_dot_space validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	alphabetic_dot_space: function (value) {
		var filter = /^[a-z \.\_]+$/i;
		if (typeof value !== 'string' || !filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Alphanumeric_dot_space validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	alphanumeric_dot_space: function (value) {
		var filter = /^[a-z0-9 \.\_]+$/i;
		if (typeof value !== 'string' || !filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Alphanumeric_minus validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	alphanumeric_minus: function (value) {
		var filter = /^[a-z0-9\-]+$/i;
		if (typeof value !== 'string' || !filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Alphabetic_dot_space_add_plus_and validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	alphabetic_dot_space_add_plus_and: function (value) {
		var filter = /^[a-z \.\_\@\+\&]+$/i;
		if (typeof value !== 'string' || !filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Alphabetic_dot_space_add_plus_and_minus validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	alphabetic_dot_space_add_plus_and_minus: function (value) {
		var filter = /^[a-z \.\-\_\@\+\&]+$/i;
		if (typeof value !== 'string' || !filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Alphanumeric_dot_space_minus validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	alphanumeric_dot_space_minus: function (value) {
		var filter = /^[a-z0-9 \.\-]+$/i;
		if (typeof value !== 'string' || !filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Alphanumeric_dot_space_add_plus_and validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	alphanumeric_dot_space_add_plus_and: function (value) {
		var filter = /^[a-z0-9 \.\_\@\+\&]+$/i;
		if (typeof value !== 'string' || !filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Alphanumeric_dot_space_add_plus_and_minus validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	alphanumeric_dot_space_add_plus_and_minus: function (value) {
		var filter = /^[a-z0-9 \.\-\_\@\+\&]+$/i;
		if (typeof value !== 'string' || !filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Alphanumeric_username validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	alphanumeric_username: function (value) {
		var filter = /^[a-z0-9\.\@\-]+$/i;
		if (!filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Alphabetic validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	alphabetic: function (value) {
		var filter = /^[a-z]+$/i;
		if (typeof value !== 'string' || !filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Musthavealphabetic validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	mustHaveAlphabetic: function (value) {
		var filter = /[a-z]/i;
		if (!value.match(filter)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Numeric validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	numeric: function (value) {
		if (!validators.helpers.isNumeric(value) || value === null || value === '' || Array.isArray(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Numericnodecimals validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	numericNoDecimals: function (value) {
		var filter = /^[0-9]+$/;
		if (typeof value !== 'string' || !filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Csv_only_numeric validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	csv_only_numeric: function (value) {
		var valueArray = value.replace(/\s+/g, '').split(',');
		for (var i = 0; i < valueArray.length; i++) {
			if (isNaN(valueArray[i]) || valueArray[i] === '') {
				return 'error';
			}
		}
		return 'success';
	},

	/**
	 * Decimalsallowed validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	decimalsAllowed: function (value) {
		var filter = /^(\d+|\d+,\d{1,2})$/;

		if (typeof value !== 'string' || !filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Negativedecimalsallowed validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	negativeDecimalsAllowed: function (value) {
		var filter = /^[+-]?[0-9]{1,9}(?:\,[0-9]{1,2})?$/;
		if (typeof value !== 'string' || !filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Decimalsallowedpipe validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	decimalsAllowedPipe: function (value) {
		var filter = /^[0-9\.\|]+$/;
		if (typeof value !== 'string' || !filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Decimalsallowednochange validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	decimalsAllowedNoChange: function (value) {
		value = formatters.dotToComma(value);
		var filter = /^(\d+|\d+,\d{1,2})$/;
		if (typeof value !== 'string' || !filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Decimalsrequired validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	decimalsRequired: function (value) {
		var filter = /^[0-9]+\,[0-9][0-9]$/;
		if (typeof value !== 'string' || !filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Negativedecimalsrequired validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	negativeDecimalsRequired: function (value) {
		var filter = /^[+-]?[0-9]+\,[0-9][0-9]$/;
		if (typeof value !== 'string' || !filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Email validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	email: function (value) {
		var filter = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,61}$/;
		if (typeof value !== 'string' || !filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Date validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	date: function (value) {
		var m = value.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
		if (m == null) {
			return 'error';
		} else {
			var d = new Date(m[3], m[2] - 1, m[1]);
			if (d.getDate() + '-' + (d.getMonth() + 1) + '-' + d.getFullYear() != m[1] * 1 + '-' + m[2] * 1 + '-' + m[3] * 1) {
				return 'error';
			}
		}
		return 'success';
	},

	/**
	 *
	 * @param {string} value
	 * @param {array} settings
	 * @returns {string}
	 */
	daterange: function (value, settings) {
		var enteredDate, startDate, endDate;

		var m = value.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
		if (null !== m && null !== m[3]) {
			enteredDate = Date.parse(new Date(m[3], m[2] - 1, m[1]));
			startDate = Date.parse(new Date(m[3], m[2] - 1, m[1]));
			endDate = Date.parse(new Date(m[3], m[2] - 1, m[1]));
		}

		var field1 = settings[0];
		if (field1 !== undefined && field1 !== null && field1 !== '') {
			m = field1.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
			if (null !== m && null !== m[3]) {
				startDate = Date.parse(new Date(m[3], m[2] - 1, m[1]));
			}
		}

		var field2 = settings[1];
		if (field2 !== undefined && field2 !== null && field2 !== '') {
			m = field2.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
			if (null !== m && null !== m[3]) {
				endDate = Date.parse(new Date(m[3], m[2] - 1, m[1]));
			}
		}

		if (startDate == null || endDate == null || enteredDate == null || enteredDate < startDate || enteredDate > endDate) {
			if (settings[3] == 'noError') {
				return 'warning';
			} else {
				return 'error';
			}
		}
		return 'success';
	},

	/**
	 * Daterangetodaywarning validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	daterangeTodayWarning: function (value) {
		var startDate = new Date();
		startDate.setDate(startDate.getDate() - 1);
		var m = value.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
		var enteredDate = Date.parse(new Date(m[3], m[2] - 1, m[1]));
		if (Date.parse(startDate) > enteredDate) {
			return 'warning';
		}
		return 'success';
	},

	/**
	 * Daterangetodaydanger validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	daterangeTodayDanger: function (value) {
		var startDate = new Date();
		startDate.setDate(startDate.getDate() - 1);
		var m = value.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
		var enteredDate = Date.parse(new Date(m[3], m[2] - 1, m[1]));
		if (Date.parse(startDate) > enteredDate) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Datemonthyear validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	datemonthyear: function (value) {
		var m = value.match(/^(\d{1,2})-(\d{4})$/);
		if (m === null) {
			return 'error';
		}
		var month = parseInt(m[1], 10);
		if (month < 1 || month > 12) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Kvk validator
	 *
	 * @param {string} value
	 * @returns {string}
	 */
	kvk: function (value) {
		var filter = /^[0-9]+$/;
		if (!validators.helpers.isNumeric(value) || value.length !== 8 || !filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Loonheffingennummer validator
	 *
	 * @param {string} value
	 * @returns {string}
	 */
	loonheffingennummer: function (value) {
		var filter = /^[0-9]+$/;
		if (!validators.helpers.isNumeric(value) || value.length !== 9 || !filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * RSIN validator
	 *
	 * @param {string} value
	 * @returns {string}
	 */
	rsin: function (value) {
		var filter = /^[0-9]+$/;
		if (!validators.helpers.isNumeric(value) || value.length !== 9 || !filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Range validator
	 *
	 * @param {string} value
	 * @param {array} settings
	 *
	 * @returns {string}
	 */
	range: function (value, settings) {
		var field1 = settings[0];
		var field2 = settings[1];
		var value_check = parseFloat(value.replace(',', '.'));
		var minValue = parseFloat(field1);
		var maxValue = parseFloat(field2);
		if (value_check < minValue || value_check > maxValue) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Maxchar validator
	 *
	 * @param {string} value
	 * @param {array} settings
	 *
	 * @returns {string}
	 */
	maxchar: function (value, settings) {
		var length = settings[0];
		if (value.length > length) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Minchar validator
	 *
	 * @param {string} value
	 * @param {array} settings
	 *
	 * @returns {string}
	 */
	minchar: function (value, settings) {
		var length = settings[0];
		if (value.length < length) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Gsm validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	gsm: function (value) {
		var filter = /^(((\\0)6){1}[1-9]{1}[0-9]{7})$/i;
		filter = /^((06){1}[1-9]{1}[0-9]{7})$/i;
		if (typeof value !== 'string' || !filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Phone validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	phone: function (value) {
		var filter = /^(((0)[1-9]{2}[0-9][\-]?[1-9][0-9]{5})|((0)[1-9][0-9][\-]?[1-9][0-9]{6})|(06){1}[1-9]{1}[0-9]{7})$/;
		if (typeof value !== 'string' || !filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Tel validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	tel: function (element) {
		const itiId = element.getAttribute('data-iti-id');
		let iti = window.itiInstances[itiId];
		var value = iti.telInput.value.trim();
		if ('' !== value && !iti.isValidNumber()) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Postcode validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	postcode: function (value) {
		var filter = /^[1-9][0-9]{3}[A-Z]{2}$/;
		if (typeof value !== 'string' || !filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Mustagree validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	mustAgree: function (value) {
		if (value != 'yes' && value != 'ja') {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Checkbox validation
	 *
	 * @param {input} array
	 *
	 * @returns {string}
	 */
	checkbox: function (input) {
		if (input.checked == false) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * PasswordScore validation
	 *
	 * @param {string} value
	 * @param {array} settings
	 *
	 * @returns {string}
	 */
	passwordScore: function (value, settings) {
		var score = settings[0];
		if (score <= 25) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Password2 validation
	 *
	 * @param {string} value
	 * @param {array} settings
	 *
	 * @returns {string}
	 */
	password2: function (value, settings) {
		if (settings[0] != value) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Bsn validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	bsn: function (value) {
		if (value.length == 8) {
			value = '0' + value;
		}
		if (value.length != 9) {
			return 'error';
		} else {
			var numbers = value.split('');
			var check = parseInt(numbers[0], 10) * 9 + parseInt(numbers[1], 10) * 8 + parseInt(numbers[2], 10) * 7 + parseInt(numbers[3], 10) * 6 + parseInt(numbers[4], 10) * 5 + parseInt(numbers[5], 10) * 4 + parseInt(numbers[6], 10) * 3 + parseInt(numbers[7], 10) * 2 + parseInt(numbers[8], 10) * -1;

			if (check % 11 !== 0) {
				return 'error';
			}
		}
		return 'success';
	},

	/**
	 * maxFileSize validation
	 *
	 * @param {array} settings
	 *
	 * @returns {string}
	 */
	maxFileSize: function (settings) {
		var maxfilesize = settings[0] * 1024 * 1024;
		if (typeof settings[1] !== 'undefined') {
			for (var i = 0; i < settings[1].length; ++i) {
				var size = settings[1].item(i).size;
				if (size > maxfilesize) {
					return 'error';
				}
			}
		}
		return 'success';
	},

	/**
	 * minFileSizeByte validation
	 *
	 * @param {array} settings
	 *
	 * @returns {string}
	 */
	minFileSizeByte: function (settings) {
		var minfilesize = settings[0];
		if (typeof settings[1] !== 'undefined') {
			for (var i = 0; i < settings[1].length; ++i) {
				var size = settings[1].item(i).size;
				if (size < minfilesize) {
					return 'error';
				}
			}
		}
		return 'success';
	},

	/**
	 * FileExtension validation
	 *
	 * @param {string} value
	 * @param {array} settings
	 *
	 * @returns {string}
	 */
	fileExtension: function (value, settings) {
		var field1 = settings[0];
		var fileExtension = field1.split(',');
		var valueSplit = value.toLowerCase().split('.');
		var ext = '.' + valueSplit[valueSplit.length - 1];
		if (fileExtension.indexOf(ext) == -1) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Iban validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	iban: function (value) {
		if (!ibantools.isValidIBAN(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Nosemicolon validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	nosemicolon: function (value) {
		if (value.indexOf(';') > -1) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Betalingskenmerk validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	betalingskenmerk: function (value) {
		if (value === '') {
			return 'warning';
		}

		var kenmerkArrayGecorrigeerd = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
		var kenmerkArrayGewicht = [10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
		var regex = /[\d]/g;
		var kenmerkArray = value.match(regex);
		var offset = kenmerkArrayGecorrigeerd.length - kenmerkArray.length;
		switch (kenmerkArray.length) {
			case 7:
				var filter = /^[0-9]{7}$/;
				if (typeof value !== 'string' || !filter.test(value)) {
					return 'warning';
				}
				return 'success';
			case 8:
			case 9:
			case 10:
			case 11:
			case 12:
			case 13:
			case 14:
			case 15:
			case 16:
				var beginOffset = 1;
				var C = kenmerkArray[0];
				if (kenmerkArray.length < 16) {
					var L = kenmerkArray[1];
					var calculatedL = kenmerkArray.length - 2;
					if (calculatedL > 9) {
						calculatedL = calculatedL - 10;
					}
					if (calculatedL != L) {
						return 'warning';
					}
					beginOffset = 2;
				}
				for (var i = beginOffset; i < kenmerkArray.length; i++) {
					kenmerkArrayGecorrigeerd[i + offset] = parseInt(kenmerkArray[i]);
				}
				var Som = 0;
				for (i = 0; i < kenmerkArrayGecorrigeerd.length; i++) {
					var subSom = kenmerkArrayGecorrigeerd[i] * kenmerkArrayGewicht[i];
					Som = Som + subSom;
				}
				var calculatedC = 11 - (Som % 11);
				if (calculatedC != C) {
					return 'warning';
				} else {
					var j = 0;
					var valueReturn = '';
					for (i = kenmerkArray.length - 1; i >= 0; i--) {
						if (j == 4) {
							valueReturn = '-' + valueReturn;
							j = 0;
						}
						valueReturn = kenmerkArray[i] + valueReturn;
						j++;
					}
					value = valueReturn;
				}
				return 'success';
			default:
				return 'warning';
		}
	},

	/**
	 * Salaris validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	salaris: function (value) {
		value = currency(value, {
			decimal: ',',
			separator: '.',
		});
		value = value.value;
		if (!validators.helpers.isNumeric(value) || value > 999999 || value < 100) {
			return 'error';
		} else {
			return 'success';
		}
	},

	/**
	 * Salarisnegativeallowed validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	salarisNegativeAllowed: function (value) {
		value = currency(value, {
			decimal: ',',
			separator: '.',
		});
		value = value.value;
		if (isNaN(parseFloat(value)) || value > 999999 || value < -999999 || value === 0) {
			return 'error';
		} else {
			return 'success';
		}
	},

	/**
	 * Salarisnegativeandzeroallowed validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	salarisNegativeAndZeroAllowed: function (value) {
		value = currency(value, {
			decimal: ',',
			separator: '.',
		});
		value = value.value;
		if (isNaN(parseFloat(value)) || value > 999999 || value < -999999) {
			return 'error';
		} else {
			return 'success';
		}
	},

	/**
	 * percentage validation
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	percentage: function (value) {
		if (isNaN(parseFloat(value))) {
			return 'error';
		}
		if (parseFloat(value) > 100 || parseFloat(value) < 0) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * activatieGebruikersnaam validation (A123678-054)
	 *
	 * @param {string} value
	 * @param {array} settings - settings[0] contains JSON string of allowed prefixes
	 * @returns {string}
	 */
	activatieGebruikersnaam: function (value, settings) {
		const prefixes = JSON.parse(settings[0]);
		const prefixPattern = prefixes.join('|');
		const filter = new RegExp(`^(${prefixPattern})\\d+-[0-9]{3}$`, 'i');
		if (!filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * activatieCode validation (a1234)
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	activatieCode: function (value) {
		let filter = /^[a-z][0-9]{4}$/;
		if (!filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Check of value is lowercase
	 *
	 * @param {string} value
	 *
	 * @returns {string}
	 */
	lowercase: function (value) {
		let filter = /[A-Z]/;
		if (filter.test(value)) {
			return 'error';
		}
		return 'success';
	},

	/**
	 * Check if password is strong enough
	 *
	 * @param {string} value
	 * @param {array} settings
	 *
	 * @returns {string}
	 */
	password: function (value, settings) {
		let usernameFieldQuery = settings[0] || '[name="username"]';
		let username = document.querySelector(usernameFieldQuery)?.value || '';

		let timeoutPromise = new Promise((resolve) => {
			setTimeout(() => {
				resolve('error');
			}, 1000);
		});

		let passwordStrengthPromise = new Promise((resolve) => {
			httpRequest.send(
				'POST',
				window.app.passwordStrengtUrl,
				function (data) {
					if (typeof data !== 'undefined') {
						data = JSON.parse(data);
						if (data) {
							resolve('success');
						} else {
							resolve('error');
						}
					}
				},
				httpRequest.encodeFormData({ password: value, username: username })
			);
		});

		return Promise.race([passwordStrengthPromise, timeoutPromise]);
	},

	/**
	 * SpecificValue validation
	 *
	 * Voeg attributes data-validate="specificValue" en data-specific-value="[\"##value##\",\"{t}##label##{/t}\"]" toe:
	 * ##value## is de value waarop je wil matchen, ##label## is de string in de errormelding
	 *
	 * @param {string} value de input van de gebruiker
	 * @param {array} settings bevat de te matchen value die in de specificValue attribute wordt meegegeven
	 * @returns {string}
	 */
	specificValue: function (value, settings) {
		const valueLowercase = value.toLowerCase();
		const inputValue = settings[0].toLowerCase();
		if (valueLowercase != inputValue) {
			return 'error';
		}
		return 'success';
	},
};

export default validators;
